import { QuoteStatus } from 'src/utils/QuoteStatus'
import { IGlobalInvoicePaymentDetailSummary } from './InvoicePaymentDetailsSummary'
import { BundleQuoteCheckSummary } from './BundleQuoteCheckSummary'

export interface IBundleQuoteSummary {
  currentQuoteStatus: QuoteStatus
  quotedTotal?: number | undefined
  reconciledTotal?: number | undefined
  totalQuotedCost: number
  totalReconciledCost: number
  quotedPTCount: number
  reconciledPTCount: number
  showReconciled: boolean
  quotedProfitPercentage: number
  reconciledProfitPercentage: number
  billedChargesTotal: number
  billedChargesInBundle: number
  contractTotal: number
  contractTotalInBundle: number
  receivedPTClaimCount: number
  receivedPTClaimCountInBundle: number
  payments: IGlobalInvoicePaymentDetailSummary[]
  osxOwes: number
  osxOwed: number
  profitToDate: number
  profitToDateDisplay: string
  anticipatedProfit: number
  osxOwesInBundle: number
  osxOwedInBundle: number
  profitToDateInBundle: number
  profitToDateInBundleDisplay: string
  anticipatedProfitInBundle: number
  profitMargin?: number
  profitMarginDisplay: string
  checkSummary: BundleQuoteCheckSummary
}

export class BundleQuoteSummary implements IBundleQuoteSummary {
  public currentQuoteStatus: QuoteStatus
  public quotedTotal?: number | undefined
  public reconciledTotal?: number | undefined
  public totalQuotedCost: number
  public totalReconciledCost: number
  public quotedPTCount: number
  public reconciledPTCount: number
  public showReconciled: boolean
  public quotedProfitPercentage: number
  public reconciledProfitPercentage: number
  public billedChargesTotal: number
  public billedChargesInBundle: number
  public contractTotal: number
  public contractTotalInBundle: number
  public receivedPTClaimCount: number
  public receivedPTClaimCountInBundle: number
  public payments: IGlobalInvoicePaymentDetailSummary[]
  public osxOwes: number
  public osxOwed: number
  public profitToDate: number
  public profitToDateDisplay: string
  public anticipatedProfit: number
  public osxOwesInBundle: number
  public osxOwedInBundle: number
  public profitToDateInBundle: number
  public profitToDateInBundleDisplay: string
  public anticipatedProfitInBundle: number
  public profitMargin?: number
  public profitMarginDisplay: string
  public checkSummary: BundleQuoteCheckSummary
}
